
// COMPONENTS
import loginForm from './login-form.js';

export default [
	loginForm
];

